import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { initActions } from '@app2/store/init/init.actions';
import { userActions } from '@store/user';
import { settingsActions } from '@store/settings';



@Injectable()
export class InitEffects {

  public getUser = createEffect(() => {
    return this.actions$.pipe(
      ofType(initActions.initApp),
      map(() => userActions.getUser()),
    );
  });

  public loadSettings = createEffect(() => {
    return this.actions$.pipe(
      ofType(initActions.initApp),
      map(() => settingsActions.loadSettings()),
    );
  });

  constructor(
    private actions$: Actions,
  ) {}
}
